import clsx from 'clsx';
import { Children, ReactElement, cloneElement, isValidElement, PropsWithChildren, HTMLAttributes } from 'react';

import { TabPanel, TabPanelProps } from '../tab-panel';

import './tab-panels.scss';

export const TabPanels = (props: TabPanelsProps) => {
  const { value, children, className, keepMounted = true, ...rest } = props;

  const panelChildren = Children.toArray(children).filter(
    (child): child is ReactElement<TabPanelProps> => isValidElement(child) && child.type === TabPanel
  );

  const activeTabIndex = panelChildren.findIndex((tab) => tab.props.id === value);

  const tabOffset = panelChildren.length <= 1 ? 0 : activeTabIndex * 100;

  return (
    <div className={clsx('tab-panels', className)}>
      <div
        className={clsx('tab-panel', { animated: keepMounted })}
        style={keepMounted ? { transform: `translate3d(-${tabOffset}%, 0, 0)` } : {}}
        {...rest}
      >
        {panelChildren.map((child) =>
          keepMounted || value === child.props.id
            ? cloneElement(child, {
                ...child.props,
                active: value === child.props.id,
              })
            : null
        )}
      </div>
    </div>
  );
};

interface TabPanelsProps extends PropsWithChildren<HTMLAttributes<HTMLDivElement>> {
  value: string;
  keepMounted?: boolean;
}
